import { createModalStore } from '@/shared/lib/modal';

import type { BookSalesDemoSource } from '../lib/sources';

type BookSalesDemoState = {
  source: BookSalesDemoSource | null;
  sourceText: null | string;
};

export const useBookSalesDemoStore = createModalStore<BookSalesDemoState>({ source: null, sourceText: null }, false);
